<page-toolbar [pageActions]="pageActions" [title]="'myUsers.title' | translate"></page-toolbar>

<div class="content-container">
  <mat-tab-group>
    <mat-tab label="{{'myUsers.profiles' | translate}}">
      <mat-tab-group (selectedTabChange)="filterByLabel($event)" *ngIf="!!labels?.length" class="sub-tabs">
        <mat-tab label="{{'myUsers.all' | translate}}"></mat-tab>
        <mat-tab (click)="filterByLabel(label._id)" *ngFor="let label of labels" [label]="label.title"></mat-tab>
      </mat-tab-group>
      <data-table (edit)="onEdit($event)" (remove)="onRemove($event)" [checkBoxActions]="checkBoxActions" [columns]="columns"
                      [dataProviderParams]="params" [dataProvider]="frontProfilesService" [perPage]="true"
                      [searchColumns]="searchColumns" table_id="frontProfiles" [searchAll]="true"></data-table>
    </mat-tab>

    <mat-tab label="{{'myUsers.groups' | translate}}" *ngIf="groupIds?.length">
      <data-table (edit)="onEditGroup($event)" *ngIf="groupParams" [columns]="groupColumns" [dataProviderParams]="groupParams"
                      [dataProvider]="groupService" table_id="frontProfileGroups"></data-table>
    </mat-tab>

    <mat-tab label="{{'myUsers.addressbooks' | translate}}" *ngIf="groupIds?.length">
      <data-table (edit)="onEditGroup($event)" *ngIf="chatGroupParams" [columns]="groupColumns" [dataProviderParams]="chatGroupParams"
                      [dataProvider]="groupService" table_id="frontProfileGroups"></data-table>
    </mat-tab>

    <mat-tab label="{{'myUsers.labels' | translate}}" *ngIf="labels?.length">
      <data-table *ngIf="labels?.length" (edit)="onEditLabel($event)" (remove)="onRemoveLabel($event)" [columns]="labelColumns"
                      [dataProviderParams]="labelParams" [dataProvider]="labelService" table_id="labelTable" #labelTable></data-table>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!!myPackage?.ibexApp?.allowedFrontProfiles" class="tab-group-info">
    <span class="limit {{checkLimit(myPackage.ibexApp.allowedFrontProfiles, frontProfilesCount)}}"
    >{{'myUsers.profileUsage' | translate}} {{frontProfilesCount}}/{{myPackage.ibexApp.allowedFrontProfiles}}</span>
    <span *ngIf="isChatModuleAdmin" class="limit {{checkLimit(myPackage.ibexApp.allowedChatProfiles, chatProfilesCount)}}"
    >{{'myUsers.chatProfileUsage' | translate}} {{chatProfilesCount}}/{{myPackage.ibexApp.allowedChatProfiles}}</span>
  </div>
</div>

<div *ngIf="isLoading" class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
